// extracted by mini-css-extract-plugin
export default {"editProductModal":"EditProductModal_editProductModal__oOXYH","formGroup":"EditProductModal_formGroup__EFNeQ","autofilled":"EditProductModal_autofilled__oFyZo"};